import validator from "./validator";

const urlParam = {
  getValidId: (value: string | number): number | null => {
    if (!validator.isPositiveInteger(value)) {
      return null;
    }
    return Number(value);
  },
};

export default urlParam;
